<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nRYOT1/tc-custom/cover.jpg?1688984940976?1735587017417" alt="This image is the cover for the book PHYSICS C (ELECTRICITY & MAGNETISM), Advanced Placement Test Series (AP)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">PHYSICS C (ELECTRICITY & MAGNETISM), Advanced Placement Test Series (AP)
      </h1>
      <p class="bookDescription body article font2">
        <p>The Advanced Placement Test Program permits high school students to gain college credit and/or advanced placement in college by excelling on subject exams. The AP Physics C (Electricity &amp; Magnetism) Passbook® contains practice tests consisting of hundreds of multiple choice questions and answers in the areas that will likely be covered on your upcoming exam.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        National Learning Corporation
      </h2>
      
      <p class="authorDescription body article">National Learning Corporation has been a leading publisher of test-preparation Passbooks® for more than 50 years, with 6,000 titles available across 22 series.  The Career Examination Series features thousands of titles designed to prepare test candidates for their upcoming civil-service job exam.  Each book in the Career Series offers practice through multiple-choice questions and answers in relevant subject areas, as well as informative texts to aid in understanding the study material.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      National Learning Corporation
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d4c66b1a